<template>
  <div>
    <navbar
      :min-nav="navbarMinimize"
      :toggle="toggleConfigurator"
      :class="isNavFixed ? navbarFixed : ''"
    />
  </div>
  <div
    class="mx-3 mt-3 border-radius-xl position-relative"
  >
    <main class="mt-1 main-content border-radius-lg">
      <div
        class="section position-relative transform-scale-0 transform-scale-md-7"
        style="min-height: 89vh;"
      >
        <div class="container-fluid">
          <div class="pt-5 row justify-content-center">
            <div class="col-lg-8 col-md-11">
              <div class="d-flex">
                <div class="me-auto">
                  <h1 class="mb-0 display-3 font-weight-bold mt-n4">제조사 선택</h1>
                  <h6 class="mb-0 text-uppercase ms-1">Choose a Manufacturer</h6>
                </div>
                <div class="ms-auto">
                </div>
              </div>
              <div class="mt-4 row">
                <div class="card h-100">
                  <div class="p-3 pb-0 card-header">
                  </div>
                  <div class="p-3 card-body">
                    <ul class="list-group">
                      <li
                        v-for="(mf, index) in manufacturerList"
                        :key="index"
                        class="px-0 mb-2 border-0 list-group-item d-flex align-items-center list-group-item-action"
                        @click="selectManufacturer(mf)"
                      >
                        <soft-avatar
                          class="m-3"
                          :img="mf.logoImageUrl"
                          alt="kal"
                          border-radius="lg"
                          shadow="regular"
                          :size="'xxl'"
                        />
                        <div
                          class="d-flex align-items-start flex-column justify-content-center ms-3"
                        >
                          <h6 class="mb-0 text-2xl">{{ mf.name }}</h6>
                          <p class="mb-0">{{ mf.address }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  <app-footer class="py-3 bg-white border-radius-lg" />
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import AppFooter from "@/examples/Footer.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import SoftAvatar from "@/components/SoftAvatar.vue";
import api from '@/api/api';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "SelMf",
  components: {
    AppFooter,
    Navbar,
    SoftAvatar,
  },
  data() {
    return {
      manufacturerList: [],
    };
  },
  computed: {
    ...mapState(["isTransparent", "isNavFixed", "navbarFixed", "mcolor"]),
  },
  mounted() {
    this.fetchData();
  },
  beforeMount() {
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.add("mf-sel");
    this.$store.state.isTransparent = "bg-white";
  },
  beforeUnmount() {
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.remove("mf-sel");

    if (this.$store.state.isPinned === false) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      sidenav_show.classList.remove("g-sidenav-hidden");
      sidenav_show.classList.add("g-sidenav-pinned");
      this.$store.state.isPinned = true;
    }
    this.$store.state.isTransparent = "bg-transparent";
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions("UserStore", ["updateMfInfo"]),
    async fetchData() {
      try {
        const grpId = localStorage.getItem("grpId");
        const response = await api.get(`/manufacturer/list?grpId=${grpId}`);
        const result = response.data.result;

        this.manufacturerList = result.manufacturerList;

      } catch (error) {
        console.error("통계 정보 불러오기 실패:", error);
      }
    },
    selectManufacturer(mf) {
      this.updateMfInfo({
        companyPrefix: mf.companyPrefix,
        name: mf.name,
        address: mf.address,
        logoImg: mf.logoImg,
      });
      this.$router.push("/dashboard");
    },
  },
};
</script>
<style scoped>
.list-group-item:hover {
  background-color: #e9ecef; /* 부트스트랩 회색 계열 */
  cursor: pointer;
  transition: background-color 0.3s ease;
}

</style>